import { render } from "./App.vue?vue&type=template&id=efc20840"
const script = {}

import "./App.vue?vue&type=style&index=0&id=efc20840&lang=css"

import exportComponent from "E:\\Web\\forgexsystem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__